"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BubbleGroup = void 0;
var BasketUpdatedEvent = _interopRequireWildcard(require("@ori-events/basket-updated"));
var ToggleMenuFlyoutEvent = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _react = require("react");
var _reactTransitionGroup = require("react-transition-group");
var _uuid = require("uuid");
var _constants = require("../../constants");
var _utils = require("../../utils");
var _Bubble = require("../Bubble");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BubbleGroup = () => {
  const [bubbles, setBubbles] = (0, _react.useState)([]);
  const removeBasketBubble = bubbleId => {
    setBubbles(currentBubbles => currentBubbles.filter(currentBubble => currentBubble.id !== bubbleId));
  };
  const onToggleMenuFlyout = event => {
    const {
      menuType
    } = event.detail;
    if (menuType === ToggleMenuFlyoutEvent.MenuTypes.Minibag && (0, _utils.isMinibagVisible)()) {
      // hide all bubbles when minibag is being opened
      setBubbles([]);
    }
  };
  const onBasketUpdate = event => {
    // don't show bubble if not add-to-basket update or if minibag is visible
    if (!event.detail.lastAddedItem || (0, _utils.isMinibagVisible)()) {
      return;
    }
    const {
      itemCode,
      method,
      frequency
    } = event.detail.lastAddedItem;
    const {
      shoppingBagItems,
      offers
    } = event.detail.shoppingBag;
    const offersItems = offers.reduce((acc, offer) => [...acc, ...offer.items], []);

    // proper typing for method -- TODO
    const methodType = method;
    const item = methodType === BasketUpdatedEvent.LastAddedItemMethod.BUY_FOR_MONEY ? shoppingBagItems.find(product => product.itemCode === itemCode) : offersItems.find(product => product.itemCode === itemCode);
    if (!item) {
      return;
    }
    const bubble = {
      id: (0, _uuid.v4)(),
      code: item.itemCode,
      name: item.itemDescription,
      price: item.totalPrice,
      quantity: item.requestedQuantity,
      image: item.itemImageSrc,
      points: item.totalRedeemedPoints,
      frequency,
      methodType,
      nodeRef: /*#__PURE__*/(0, _react.createRef)()
    };
    setBubbles(currentBubbles => [...currentBubbles, bubble]);
    setTimeout(() => removeBasketBubble(bubble.id), _constants.bubbleDuration);
  };
  (0, _react.useEffect)(() => {
    window.addEventListener(BasketUpdatedEvent.Name, onBasketUpdate);
    window.addEventListener(ToggleMenuFlyoutEvent.Name, onToggleMenuFlyout);
    return () => {
      window.removeEventListener(BasketUpdatedEvent.Name, onBasketUpdate);
      window.removeEventListener(ToggleMenuFlyoutEvent.Name, onToggleMenuFlyout);
    };
  });
  const timeoutSettings = {
    appear: 0,
    enter: 0,
    exit: 1250
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BasketBubbleWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTransitionGroup.TransitionGroup, {
      children: bubbles.map(({
        id,
        nodeRef,
        ...bubble
      }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactTransitionGroup.Transition, {
        nodeRef: nodeRef,
        timeout: timeoutSettings,
        children: state => {
          const bubbleOwnerState = {
            state
          };
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AnimationWrapper, {
            ref: nodeRef,
            ownerState: bubbleOwnerState,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Bubble.Bubble, {
              ...bubble
            }, id)
          }, id);
        }
      }, id))
    })
  });
};
exports.BubbleGroup = BubbleGroup;
